export default function () {
    const equalTextHeight = (uid) => {
        const $textBox = document.querySelector('#ce__isnack-stageslider-' + uid + ' .ce__isnack-imagetext-tbg-content-box');
        if (window.matchMedia('(max-width: 991px)').matches) {
            let $itemHeight = 0;
            const paddingSpacer = 30;
            document.querySelectorAll('#ce__isnack-stageslider-' + uid + ' .ce__isnack-stageslider-slider-item').forEach((item) => {
                item.classList.add('d-block');
                if (item.offsetHeight > $itemHeight) {
                    $itemHeight = item.offsetHeight;
                }
                item.classList.remove('d-block');
            });
            $textBox.style.height = ($itemHeight + paddingSpacer) + 'px';
        } else {
            $textBox.style.height = 'auto';
        }
    };

    const replaceSliderContent = (sliderIndex, slider) => {
        // get current item
        const current = document.querySelector('#' + slider.id + '-item-' + sliderIndex);
        // eslint-disable-next-line prefer-destructuring
        const bgcolor = current.dataset.bgcolor;
        // eslint-disable-next-line prefer-destructuring
        const uid = current.dataset.uid;
        // eslint-disable-next-line prefer-destructuring
        let bgi = '';
        if (current.dataset.bgi) {
            bgi = current.dataset.bgi;
        }

        // start change bg color
        Array.from(document.querySelectorAll('#ce__isnack-stageslider-' + uid + ' .bg__animated')).forEach((item) => {
            for (let i = item.classList.length - 1; i >= 0; i--) {
                const className = item.classList[i];
                if (className.startsWith('bg__isnack')) {
                    item.classList.remove(className);
                }
            }

            setTimeout(() => {
                item.classList.add('bg__isnack-' + bgcolor);
            });
        });
        // end change bg color

        // start change textbox
        Array.from(document.querySelectorAll('#ce__isnack-stageslider-' + uid + ' .ce__isnack-stageslider-slider-item')).forEach((item) => {
            item.classList.remove('ce__isnack-stageslider-slider-item-active');
            item.classList.remove('ce__isnack-stageslider-slider-item-start');
        });

        setTimeout(() => {
            current.classList.add('ce__isnack-stageslider-slider-item-active');
        });
        // end change textbox

        // start change bg image
        if (bgi) {
            document.querySelector('#ce__isnack-stageslider-' + uid + ' .bg__animated').style.backgroundImage = 'url(' + bgi + ')';
        }
        // end change bg image
    };

    const changeActiveBullet = (sliderIndex, activeBullet, bulletsContainerElementDesktop, bulletsContainerElementMobile) => {
        // start desktop bullets
        const glideDirDesktop = bulletsContainerElementDesktop.querySelector('[data-glide-dir="=' + sliderIndex + '"]');
        bulletsContainerElementDesktop.querySelector('.' + activeBullet).classList.remove(activeBullet);
        if (glideDirDesktop) {
            glideDirDesktop.classList.add(activeBullet);
        }
        // end desktop bullets

        // start mobile bullets
        const glideDirMobile = bulletsContainerElementMobile.querySelector('[data-glide-dir="=' + sliderIndex + '"]');
        bulletsContainerElementMobile.querySelector('.' + activeBullet).classList.remove(activeBullet);
        if (glideDirMobile) {
            glideDirMobile.classList.add(activeBullet);
        }
        // end mobile bullets
    };

    // run glide slider
    document.addEventListener('DOMContentLoaded', () => {
        const $stagesliderItems = document.querySelectorAll('.ce__isnack-stageslider-slider');

        if (!$stagesliderItems.length) {
            return;
        }

        $stagesliderItems.forEach((slider) => {
            const slidesSelector = '#' + slider.id + ' .glide__slide';
            const $slides = slider.querySelectorAll(slidesSelector);

            // only initialize a slider when we have more than one slide
            if ($slides.length > 1) {
                // get controls outside glide container
                const current = document.querySelector('#' + slider.id);
                // eslint-disable-next-line prefer-destructuring
                const uid = current.dataset.uid;
                const $sliderleftArrow = document.querySelector('#ce__isnack-stageslider-' + uid + ' .glide__controls-desktop .glide__arrow--left');
                const $sliderrightArrow = document.querySelector('#ce__isnack-stageslider-' + uid + ' .glide__controls-desktop .glide__arrow--right');

                // start const pagination bullet fix
                // eslint fix "This line has a length of 158. Maximum allowed is 150  max-len"
                const selectorBulletsContainerElementDesktop = '#ce__isnack-stageslider-' + uid + ' .glide__controls-desktop .glide__bullets';
                const bulletsContainerElementDesktop = document.querySelector(selectorBulletsContainerElementDesktop);
                const bulletsContainerElementMobile = slider.querySelector('.glide__bullets');
                const activeBullet = 'glide__bullet--active';
                // end const pagination bullet fix

                // responsive/breakpoints settings
                const gapItem = 0;
                const slidesPerView = 1;

                // set autoplay
                let intval = 5000;
                // eslint-disable-next-line prefer-destructuring
                const autoplay = parseInt(current.dataset.autoplay, 2); // radix base 2 for bool, base 10 for integer
                if (autoplay === 1) {
                    intval = 5000;
                } else {
                    intval = 0;
                }

                const $stagesliderGlide = new Glide('#' + slider.id, {
                    type: 'carousel',
                    // eslint-disable-next-line prefer-destructuring
                    autoplay: intval,
                    animationDuration: 2000,
                    gap: gapItem,
                    perView: slidesPerView,
                });

                $sliderleftArrow.addEventListener('click', (event) => {
                    event.preventDefault();
                    $stagesliderGlide.go('<');
                });

                $sliderrightArrow.addEventListener('click', (event) => {
                    event.preventDefault();
                    $stagesliderGlide.go('>');
                });

                $stagesliderGlide.mount();

                $stagesliderGlide.on(['run'], () => {
                    replaceSliderContent($stagesliderGlide.index, slider);
                    changeActiveBullet($stagesliderGlide.index, activeBullet, bulletsContainerElementDesktop, bulletsContainerElementMobile);
                });
            }

            // start equal height textbox
            const current = document.querySelector('#' + slider.id);
            // eslint-disable-next-line prefer-destructuring
            const uid = current.dataset.uid;
            const $textBoxItem = document.querySelectorAll('#ce__isnack-stageslider-' + uid + ' .ce__isnack-stageslider-slider-item');
            if ($textBoxItem.length > 0) {
                window.addEventListener('load', () => {
                    equalTextHeight(uid);
                });

                window.addEventListener('resize', () => {
                    setTimeout(() => {
                        equalTextHeight(uid);
                    });
                });

                // mobile devices rotation
                window.addEventListener('orientationchange', () => {
                    setTimeout(() => {
                        equalTextHeight(uid);
                    });
                });
            }
            // end equal height textbox
        });
    });
}
